"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchHeader = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _contexts = require("../../contexts");
var _Breadcrumbs = require("../BreadCrumbs/Breadcrumbs");
var _SearchInput = require("../SearchInput/SearchInput");
var _SearchHeaderTitle = require("./SearchHeaderTitle");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchHeader = ()=>{
    const rootPath = '/';
    const path = (0, _reactRouterDom.useLocation)();
    const isRootPath = rootPath === path.pathname;
    const { query, resetSearchResults } = (0, _contexts.useSearchResultContext)();
    const [inputValue, setInputValue] = (0, _react.useState)(query);
    (0, _react.useEffect)(()=>{
        if (isRootPath) {
            resetSearchResults();
            setInputValue('');
        } else {
            setInputValue(query);
        }
    }, [
        isRootPath,
        query,
        resetSearchResults
    ]);
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId('top-banner'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.BreadcrumbsWrapper, {
                "data-testid": getTestId('top-banner-breadcrumbs'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Breadcrumbs.Breadcrumbs, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchHeaderTitle.SearchHeaderTitle, {
                isRootPath: isRootPath
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchInput.SearchInput, {
                inputValue: inputValue,
                setInputValue: setInputValue
            })
        ]
    });
};
exports.SearchHeader = SearchHeader;
